<template>
  <title-card title="Summary">
    <b-col sm="12" class="mb-1 mt-9">
      <b-row class="mb-1">
        <b-col class="label text-right"><strong>Loan #: </strong></b-col>
        <b-col> {{ loan.number }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col class="label text-right"> Address:</b-col>
        <b-col> {{ loan.property.address }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col class="label text-right"> City:</b-col>
        <b-col> {{ loan.property.city }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col class="label text-right"> State, Zip:</b-col>
        <b-col> {{ loan.property.state }}, {{ loan.property.zip_code }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col class="label text-right"> Entity:</b-col>
        <b-col>
          <a href="#" @click="entityClicked(entity)">
            {{ entityName }}
          </a>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col class="label text-right"> Loan Type:</b-col>
        <b-col class="capitalize"> {{ loan.transaction_type }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col class="label text-right"> Loan Amount:</b-col>
        <b-col> {{ loan.amount | currency }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col class="label text-right"> Terms (months):</b-col>
        <b-col> {{ loan.loan_terms }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col class="label text-right"> Rate:</b-col>
        <b-col> {{ loan.loan_rate }}%</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col class="label text-right"> Funded Date:</b-col>
        <b-col>
          {{ loan.funded_date | date}}
          {{ loan.checklist.funded | date}}
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col class="label text-right"> Initial Holdback:</b-col>
        <b-col> {{ loan.ess.holdback | currency }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col class="label text-right"> Current Balance:</b-col>
        <b-col> {{ loan.holdback_balance | currency }}</b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col class="label text-right"> Current Due:</b-col>
        <b-col v-if="loan.servicing_current_pay_amount">
          {{ loan.servicing_current_pay_amount | currency }}
        </b-col>
        <b-col v-else> - </b-col>
      </b-row>
      <b-row class="mb-1">
        <b-col class="label text-right"> Maturity Date:</b-col>
        <b-col> {{ loan.maturity_date | date }}</b-col>
      </b-row>
    </b-col>
  </title-card>
</template>

<script>
import TitleCard from '@/components/utils/TitleCard';

export default {
  components: {
    TitleCard,
  },
  props: {
    loan: {
      type: Object,
      required: true,
    },
    entity: Object,
  },
  computed: {
    entityName() {
      if (this.entity) {
        return this.entity.name;
      }
      return '';
    },
  },
  methods: {
    entityClicked(entity) {
      if (this.entity) {
        this.$router.push({ name: 'EntityDetails', params: { id: entity.id } });
      }
    },
  },
};
</script>

<style scoped>
  .label {
    font-weight: bolder;
  }
  .capitalize {
    text-transform: capitalize;
  }
  .mb-1, .my-1 {
    margin-bottom: 1.25rem !important;
  }
  @media (min-width: 1333px) {
    .raised.p-3.rounded.mt-sm-3 {
      height: 98% !important;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/my_deals/deals/LoanActiveAttributes.vue